import { render, staticRenderFns } from "./ExchangeDetailsInterested.vue?vue&type=template&id=728b7842&"
import script from "./ExchangeDetailsInterested.vue?vue&type=script&lang=js&"
export * from "./ExchangeDetailsInterested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports